
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import TextField from '@/components/shared/TextField.vue';

type EmitType = 'cancel' | 'confirm' | 'close';

@Component<TypeToConfirmModal>({
	components: {
		StandardModal,
		TextField
	}
})
export default class TypeToConfirmModal extends Vue {
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Boolean, default: false }) private loading!: boolean;
	@Prop({ type: Boolean, default: false }) private nested!: boolean;
	@Prop({ type: String, required: false, default: '' }) private title!: string;
	@Prop({ type: String, required: false, default: '' }) private text!: string;
	@Prop({ type: String, required: true }) private confirmationString!: string;
	@Prop({ type: String, required: true }) private inputLabel!: string;
	@Prop({ type: String, required: true }) private inputId!: string;
	@Prop({ type: String, required: false, default: '' }) private cancelButtonText!: string;
	@Prop({ type: String, required: false, default: '' }) private confirmButtonText!: string;
	@Prop({ type: String, required: false }) private customClass!: string;
	@Prop({ type: Boolean, default: false }) private disableConfirm!: boolean;
	@Watch('showModal')
	private onShowModalChange(value: boolean): void {
		// Reset the input whenever the modal closes, so it reopens with an empty input.
		if (!value) {
			this.confirmInput = '';
		}
	}

	private confirmInput: string = '';

	private get isConfirmDisabled(): boolean {
		return this.disableConfirm || this.confirmInput.trim() !== this.confirmationString;
	}

	/**
	 * Emit cancel or confirm event if it isn't loading
	 *
	 * @param {EmitType} type
	 * @return {void}
	 */
	private emit(type: EmitType): void {
		!this.loading && this.$emit(type);
	}
}
